import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AiStudioComponent } from './ai-studio/ai-studio.component';
import { CanvasViewComponent } from './canvas-view/canvas-view.component';
import { AiStudioContainerComponent } from './ai-studio-container/ai-studio-container.component';
import { aiStudioCurrentSessionGuard } from './ai-studio-container/ai-studio-current-session.guard';
import { PromoPlanUploadComponent } from './promo-plan/promo-plan-upload/promo-plan-upload.component';
// import { PromoPlanComponent } from './promo-plan/promo-plan.component';
import { ViewPromoPlanComponent } from './promo-plan/view-promo-plan/view-promo-plan.component';
import { SelloutUploadComponent } from './sellout/sellout-upload/sellout-upload.component';
import { ViewSelloutComponent } from './sellout/view-sellout/view-sellout.component';

// Guards
import { rootRedirectGuard } from './guards/root-redirect.guard';
import { authGuard } from './guards/auth.guard';
import { publicGuard } from './guards/public.guard';
import { canUploadPromoPlanGuard } from './promo-plan/promo-plan.guard';
import { canUploadSelloutGuard } from './sellout/sellout.guard';
import { canCreateSettlementsGuard } from './settlement/settlement.guard';
import { EmptyRouteComponent } from './guards/empty-route.component';
import { StatusWorkflowManagerComponent } from './workflow-config/workflow-config.component';
import {
  canCreateActivityTypesGuard,
  canCreateBranchesGuard,
  canCreateBrandsGuard,
  canCreateBusinessesGuard,
  canCreateBusinessUnitsGuard,
  canCreateClaimContractsGuard,
  canCreateFixedBySiteRebatesGuard,
  canCreateFixedRebatesGuard,
  canCreateItemsGuard,
  canCreateProgressiveRebatesGuard,
  canCreateRolesGuard,
  canCreateSubBrandsGuard,
  canCreateSuppliersGuard,
  canCreateSupplierSitesGuard,
  canCreateUsersGuard,
  canManageWorkflowConfigGuard,
  canReadActivityTypesGuard,
  canReadBranchesGuard,
  canReadBrandsGuard,
  canReadBusinessesGuard,
  canReadBusinessUnitsGuard,
  canReadClaimContractsGuard,
  canReadClaimResultsGuard,
  canReadCustomersGuard,
  canReadItemsGuard,
  canReadKBDsGuard,
  canReadLoactionsGuard,
  canReadRebateResultsGuard,
  canReadRolesGuard,
  canReadSubBrandsGuard,
  canReadSuppliersGuard,
  canReadSupplierSitesGuard,
  canReadUsersGuard,
  canUpdateActivityTypesGuard,
  canUpdateBranchesGuard,
  canUpdateBrandsGuard,
  canUpdateBusinessesGuard,
  canUpdateBusinessUnitsGuard,
  canUpdateClaimContractsGuard,
  canUpdateItemsGuard,
  canUpdateKBDsGuard,
  canUpdateRolesGuard,
  canUpdateSubBrandsGuard,
  canUpdateSuppliersGuard,
  canUpdateSupplierSitesGuard,
  canUpdateUsersGuard,
} from './guards/master-data.guard';

import { ListPromoPlanComponent } from './promo-plan/list-promo-plan/list-promo-plan.component';
import { ListSelloutComponent } from './sellout/list-sellout/list-sellout.component';
import { ListUsersComponent } from './users/list-users/list-users.component';
import { EditUserComponent } from './users/edit-user/edit-user.component';

// import { SettingsComponent } from './settings/settings.component';
import { ListSettlementComponent } from './settlement/list-settlement/list-settlement.component';
import { ViewSettlementComponent } from './settlement/view-settlement/view-settlement.component';
import { AddEditSettlementComponent } from './settlement/add-edit-settlement/add-edit-settlement.component';
import { BusinessListComponent } from './master-data/business/business-list/business-list.component';
import { BusinessFormComponent } from './master-data/business/business-form/business-form.component';
import { BranchesComponent } from './master-data/branches/branches.component';
import { EditBranchComponent } from './master-data/branches/edit-branch/edit-branch.component';
import { ListBranchComponent } from './master-data/branches/list-branch/list-branch.component';
import { BrandFormComponent } from './master-data/brands/brands-form/brands-form.component';
import { BrandsListComponent } from './master-data/brands/brands-list/brands-list.component';
import { BusinessUnitsListComponent } from './master-data/business-units/business-units-list/business-units-list.component';
import { EditBusinessUnitComponent } from './master-data/business-units/edit-business-unit/edit-business-unit.component';
import { FormSuppliersComponent } from './master-data/suppliers/form-suppliers/form-suppliers.component';
import { ListSuppliersComponent } from './master-data/suppliers/list-suppliers/list-suppliers.component';
import { FormRoleComponent } from './master-data/roles/form-role/form-role.component';
import { ListRolesComponent } from './master-data/roles/list-roles/list-roles.component';
import { ArchivedSessionsComponent } from './archived-sessions/archived-sessions.component';
import { SubBrandsListComponent } from './master-data/brands/sub-brands/sub-brands-list/sub-brands-list.component';
import { SubBrandFormComponent } from './master-data/brands/sub-brands/sub-brands-form/sub-brands-form.component';
import { CustomersListComponent } from './master-data/customers/customers-list/customers-list.component';
import { ListActivityTypeComponent } from './master-data/activity-type/list-activity-type/list-activity-type.component';
import { EditActivityTypeComponent } from './master-data/activity-type/edit-activity-type/edit-activity-type.component';
import { FormSupplierSiteComponent } from './master-data/suppliers/supplierSite/form-supplierSite/form-supplierSite.component';
import { ListSupplierSiteComponent } from './master-data/suppliers/supplierSite/list-supplierSite/list-supplierSite.component';
import { ListItemComponent } from './master-data/items/list-item/list-item.component';
import { ItemFormComponent } from './master-data/items/item-form/item-form.component';
import { ViewItemComponent } from './master-data/items/view-item/view-item.component';
import { ListCustomerItemComponent } from './master-data/customer-item/list-customer-item/list-customer-item.component';
import { CustomerItemFormComponent } from './master-data/customer-item/customer-item-form/customer-item-form.component';
import { LocationsListComponent } from './master-data/customers/locations/locations-list/locations-list.component';
import { UserProfileComponent } from './users/user-profile/user-profile.component';
import { ContractListComponent } from './contract/contract-list/contract-list.component';
import { ContractSalesFormComponent } from './contract/contract-sales-form/contract-sales-form.component';
import { ContractFinanceFormComponent } from './contract/contract-finance-form/contract-finance-form.component';
import { ContractViewComponent } from './contract/contract-view/contract-view.component';
import { ContractCalculationListComponent } from './contract-calculation/contract-calculation-list/contract-calculation-list.component';
import { ClaimContractListComponent } from './claim-contract/claim-contract-list/claim-contract-list.component';
import { ClaimContractFormComponent } from './claim-contract/claim-contract-form/claim-contract-form.component';
import { ClaimCalculationListComponent } from './contract-calculation/claim-calculation-list/claim-calculation-list.component';
import { ContractFixedBySiteFormComponent } from './contract/contract-fixed-by-site-form/contract-fixed-by-site-form.component';
import { ContractDetailsListComponent } from './contract/contract-details-list/contract-details-list.component';
export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [publicGuard], // Redirect logged-in users away from the login page
  },
  {
    path: '',
    component: EmptyRouteComponent, // Add a component to satisfy Angular's validation
    canActivate: [rootRedirectGuard], // This guard will redirect before the component is rendered
  },
  {
    path: 'session-archive',
    component: ArchivedSessionsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'ai-studio', // Path to your new page e.g., /ai-studio
    component: AiStudioContainerComponent,
    canActivate: [authGuard], // Protect the AI Studio section
    children: [
      {
        path: '', // Default child route for /ai-studio
        component: EmptyRouteComponent, // Display a blank component or a "select a session" component
        pathMatch: 'full',
      },
      {
        path: 'session/:sessionId', // This will load SessionHostComponent into AiStudioContainerComponent's outlet
        component: AiStudioComponent,
        canActivate: [aiStudioCurrentSessionGuard],
        children: [
          // These routes are for the secondary "canvasOutlet"
          {
            path: 'canvas-view', // URL will be /ai-studio/(canvasOutlet:canvas-view)
            component: CanvasViewComponent,
            outlet: 'canvasOutlet',
          },
          {
            path: 'promo-plan',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              // {
              //   path: '',
              //   component: PromoPlanComponent,
              //   pathMatch: 'full',
              // },
              {
                path: 'upload',
                component: PromoPlanUploadComponent,
                canActivate: [canUploadPromoPlanGuard],
              },
              {
                path: 'list',
                component: ListPromoPlanComponent,
              },
              {
                path: 'view/:promoPlanId',
                component: ViewPromoPlanComponent,
              },
            ],
          },
          {
            path: 'sellout',
            outlet: 'canvasOutlet',
            children: [
              {
                path: 'upload/:settlementId',
                component: SelloutUploadComponent,
                canActivate: [canUploadSelloutGuard],
              },
              {
                path: 'list',
                component: ListSelloutComponent,
              },
              {
                path: 'view/:selloutId',
                component: ViewSelloutComponent,
              },
            ],
          },
          {
            path: 'users',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ListUsersComponent,
                canActivate: [canReadUsersGuard],
              },
              {
                path: 'create',
                component: EditUserComponent,
                canActivate: [canCreateUsersGuard],
              },
              {
                path: 'edit/:id',
                component: EditUserComponent,
                canActivate: [canUpdateUsersGuard],
              },
              {
                path: 'profile/:id',
                component: UserProfileComponent,
                canActivate: [canReadUsersGuard],
              },
            ],
          },
          {
            path: 'roles',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ListRolesComponent,
                canActivate: [canReadRolesGuard],
              },
              {
                path: 'create',
                component: FormRoleComponent,
                canActivate: [canCreateRolesGuard],
              },
              {
                path: 'edit/:id',
                component: FormRoleComponent,
                canActivate: [canUpdateRolesGuard],
              },
            ],
          },
          {
            path: 'branches',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: '',
                component: BranchesComponent,
                pathMatch: 'full',
                canActivate: [canReadBranchesGuard],
              },
              {
                path: 'list',
                component: ListBranchComponent,
                canActivate: [canReadBranchesGuard],
              },
              {
                path: 'create',
                component: EditBranchComponent,
                canActivate: [canCreateBranchesGuard],
              },
              {
                path: 'edit/:id',
                component: EditBranchComponent,
                canActivate: [canUpdateBranchesGuard],
              },
            ],
          },
          {
            path: 'businessUnit',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: BusinessUnitsListComponent,
                canActivate: [canReadBusinessUnitsGuard],
              },
              {
                path: 'create',
                component: EditBusinessUnitComponent,
                canActivate: [canCreateBusinessUnitsGuard],
              },
              {
                path: 'edit/:id',
                component: EditBusinessUnitComponent,
                canActivate: [canUpdateBusinessUnitsGuard],
              },
            ],
          },
          {
            path: 'business',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: BusinessListComponent,
                canActivate: [canReadBusinessesGuard],
              },
              {
                path: 'create',
                component: BusinessFormComponent,
                canActivate: [canCreateBusinessesGuard],
              },
              {
                path: 'edit/:id',
                component: BusinessFormComponent,
                canActivate: [canUpdateBusinessesGuard],
              },
            ],
          },
          {
            path: 'customer',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: CustomersListComponent,
                canActivate: [canReadCustomersGuard],
              },
            ],
          },
          {
            path: 'locations',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: LocationsListComponent,
                canActivate: [canReadLoactionsGuard],
              },
            ],
          },
          {
            path: 'brand',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: BrandsListComponent,
                canActivate: [canReadBrandsGuard],
              },
              {
                path: 'create',
                component: BrandFormComponent,
                canActivate: [canCreateBrandsGuard],
              },
              {
                path: 'edit/:id',
                component: BrandFormComponent,
                canActivate: [canUpdateBrandsGuard],
              },
            ],
          },
          {
            path: 'sub-brand',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: SubBrandsListComponent,
                canActivate: [canReadSubBrandsGuard],
              },
              {
                path: 'create',
                component: SubBrandFormComponent,
                canActivate: [canCreateSubBrandsGuard],
              },
              {
                path: 'edit/:id',
                component: SubBrandFormComponent,
                canActivate: [canUpdateSubBrandsGuard],
              },
            ],
          },
          {
            path: 'supplier',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ListSuppliersComponent,
                canActivate: [canReadSuppliersGuard],
              },
              {
                path: 'create',
                component: FormSuppliersComponent,
                canActivate: [canCreateSuppliersGuard],
              },
              {
                path: 'edit/:id',
                component: FormSuppliersComponent,
                canActivate: [canUpdateSuppliersGuard],
              },
            ],
          },
          {
            path: 'supplier-site',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ListSupplierSiteComponent,
                canActivate: [canReadSupplierSitesGuard],
              },
              {
                path: 'create',
                component: FormSupplierSiteComponent,
                canActivate: [canCreateSupplierSitesGuard],
              },
              {
                path: 'edit/:id',
                component: FormSupplierSiteComponent,
                canActivate: [canUpdateSupplierSitesGuard],
              },
            ],
          },
          {
            path: 'items',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ListItemComponent,
                canActivate: [canReadItemsGuard],
              },
              {
                path: 'create',
                component: ItemFormComponent,
                canActivate: [canCreateItemsGuard],
              },
              {
                path: 'edit/:id',
                component: ItemFormComponent,
                canActivate: [canUpdateItemsGuard],
              },
              {
                path: 'view/:id',
                component: ViewItemComponent,
                canActivate: [canReadItemsGuard],
              },
            ],
          },
          {
            path: 'customer-item',
            outlet: 'canvasOutlet',
            children: [
              {
                path: 'list',
                component: ListCustomerItemComponent,
              },
              {
                path: 'create',
                component: CustomerItemFormComponent,
              },
              {
                path: 'edit/:id',
                component: CustomerItemFormComponent,
              },
            ],
          },
          {
            path: 'activity-types',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ListActivityTypeComponent,
                canActivate: [canReadActivityTypesGuard],
              },
              {
                path: 'create',
                component: EditActivityTypeComponent,
                canActivate: [canCreateActivityTypesGuard],
              },
              {
                path: 'edit/:id',
                component: EditActivityTypeComponent,
                canActivate: [canUpdateActivityTypesGuard],
              },
            ],
          },
          {
            path: 'settlement',
            outlet: 'canvasOutlet',
            children: [
              {
                path: '',
                component: EmptyRouteComponent,
                pathMatch: 'full',
              },
              {
                path: 'add',
                component: AddEditSettlementComponent,
                canActivate: [canCreateSettlementsGuard],
              },
              {
                path: 'edit/:settlementId',
                component: AddEditSettlementComponent,
                canActivate: [canCreateSettlementsGuard],
              },
              {
                path: 'list',
                component: ListSettlementComponent,
              },
              {
                path: 'view/:settlementId',
                component: ViewSettlementComponent,
              },
            ],
          },
          {
            path: 'rebate',
            outlet: 'canvasOutlet',
            children: [
              {
                path: '',
                component: EmptyRouteComponent,
                pathMatch: 'full',
              },
              {
                path: 'create/fixed-rebate',
                component: ContractSalesFormComponent,
                canActivate: [canCreateFixedRebatesGuard],
              },
              {
                path: 'create/fixed-by-site-rebate',
                component: ContractFixedBySiteFormComponent,
                canActivate: [canCreateFixedBySiteRebatesGuard],
              },
              {
                path: 'create/rebate',
                component: ContractFinanceFormComponent,
                canActivate: [canCreateProgressiveRebatesGuard],
              },
              {
                path: 'edit/:contractId',
                component: ContractSalesFormComponent,
                canActivate: [canUpdateKBDsGuard],
              },
              {
                path: 'view/:contractId',
                component: ContractViewComponent,
                canActivate: [canReadKBDsGuard],
              },
              {
                path: 'list',
                component: ContractListComponent,
                canActivate: [canReadKBDsGuard],
              },
              {
                path: 'multi-export',
                component: ContractDetailsListComponent,
                canActivate: [canReadKBDsGuard],
              },
            ],
          },
          {
            path: 'rebate-results',
            outlet: 'canvasOutlet',
            children: [
              {
                path: '',
                component: EmptyRouteComponent,
                pathMatch: 'full',
              },
              {
                path: 'list',
                component: ContractCalculationListComponent,
                canActivate: [canReadRebateResultsGuard],
              },
            ],
          },
          {
            path: 'claim-results',
            outlet: 'canvasOutlet',
            children: [
              {
                path: '',
                component: EmptyRouteComponent,
                pathMatch: 'full',
              },
              {
                path: 'list',
                component: ClaimCalculationListComponent,
                canActivate: [canReadClaimResultsGuard],
              },
            ],
          },
          {
            path: 'claim-contract',
            outlet: 'canvasOutlet',
            // Component-less route to group promo plan related views
            children: [
              {
                path: 'list',
                component: ClaimContractListComponent,
                canActivate: [canReadClaimContractsGuard],
              },
              {
                path: 'create',
                component: ClaimContractFormComponent,
                canActivate: [canCreateClaimContractsGuard],
              },
              {
                path: 'edit/:id',
                component: ClaimContractFormComponent,
                canActivate: [canUpdateClaimContractsGuard],
              },
            ],
          },

          {
            path: 'status-workflow-manager',
            component: StatusWorkflowManagerComponent,
            outlet: 'canvasOutlet',
          },
          // {
          //     path: 'roles',
          //     outlet: 'canvasOutlet',
          // },
          // Add more routes for the canvasOutlet here
          // {
          //   path: 'another-view',
          //   component: AnotherCanvasComponent,
          //   outlet: 'canvasOutlet'
          // },
          {
            path: '',
            redirectTo: 'canvas-view',
            pathMatch: 'full',
            outlet: 'canvasOutlet',
          }, // Default for canvasOutlet
        ],
      },
    ],
  },
  {
    path: 'settings',
    // Assuming SettingsComponent will be created and is a standalone component
    component: EmptyRouteComponent,
    // canActivate: [authGuard] // Protect the settings page
  },
];
